import script from "./zs-manage-oss-layout.vue?vue&type=script&setup=true&lang=tsx"
export * from "./zs-manage-oss-layout.vue?vue&type=script&setup=true&lang=tsx"

import "./zs-manage-oss-layout.vue?vue&type=style&index=0&id=4f68a912&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f68a912"]])

export default __exports__